import { Card } from "@/shared/ui";
import styles from "./Dashboard.module.scss";

export function EmptyState({ title, desc }: { title: string; desc: string }) {
  return (
    <Card variant="flush">
      <div className={styles.container}>
        <div className={styles.emptyState}>
          <h2 className={styles.emptyTitle}>{title}</h2>
          <p className={styles.emptyDescription}>{desc}</p>
        </div>
      </div>
    </Card>
  );
}
